import { z } from "zod";
import { zUid } from "src/types/zUid";
import { zServFunc } from "./ZServFunc";

export const zObjectService = z.object({
  id: zUid,
  serviceId: zUid,
  objectId: zUid,
  name: z.string(),
  functions: zServFunc.array().nullish(),
});

export type ZObjectService = z.infer<typeof zObjectService>;

export type ObjectServiceExt = ZObjectService & {
  serviceKey: string;
};
